import { isValueExist } from "@/utils/utils";

export const OUTER_CONDITIONS_PATH = [0, 'conditions'];
export const getOuterConditions = R.pathOr([], OUTER_CONDITIONS_PATH);

export const checkIsFullFilter = ({ field, operator, values = [] }) => {
    const firstValue = R.head(values);
    const valueExist = R.ifElse(
        (v) => R.equals('String', R.type(v)),
        R.trim,
        isValueExist
    )(firstValue);
    return field && operator && valueExist;
};


export const countFullFilters = (code, elseCaseExists) => {
    const outerConditions = getOuterConditions(code);

    return outerConditions.reduce(
        (acc, { conditions = [] }, idx) => {
            if(elseCaseExists && idx === outerConditions.length - 1) {
                return acc;
            }
            return acc + conditions.filter(checkIsFullFilter).length;
        }, 0
    );
};

export const countFilters = (code) => {
    const outerConditions = getOuterConditions(code);

    return outerConditions.reduce(
        (acc, { conditions = [] }) => acc + conditions.length,
        0
    );
};